<script setup lang="ts">
import { features } from '../data/features';
</script>

<template>
  <section id="features" class="py-24 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-slate-900 mb-4">Technologia, która rozumie rekrutację</h2>
        <p class="text-lg text-slate-600 max-w-2xl mx-auto">Nie jesteśmy kolejnym edytorem tekstu. Jesteśmy Twoim analitykiem kariery.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-12">
        <div
          v-for="feature in features"
          :key="feature.title"
          class="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:shadow-lg transition"
        >
          <div class="bg-white w-14 h-14 rounded-full flex items-center justify-center shadow-sm mb-6">
            <component :is="feature.icon" :class="feature.iconClass" />
          </div>
          <h3 class="text-xl font-bold text-slate-900 mb-3 whitespace-pre-line">{{ feature.title }}</h3>
          <p class="text-slate-600 leading-relaxed">{{ feature.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
